import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { NbDialogService } from '@nebular/theme';
import { ModalVisualizarRequisitarCartoesComponent } from './modal-visualizar-requisitar-cartoes/modal-visualizar-requisitar-cartoes.component';
import { GestaoRequisitarCartoesDetailsService } from './gestao-requisitar-cartoes-details.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-gestao-requisitar-cartoes-details',
  templateUrl: './gestao-requisitar-cartoes-details.component.html',
  styleUrls: ['./gestao-requisitar-cartoes-details.component.scss']
})
export class GestaoRequisitarCartoesDetailsComponent implements OnInit {

  public formGestaoOnboarding = null;
  public erroLog = null;
  public rowData: any = [];
  public columnsTabe = null;
  public tableLimit = 12;
  public cpfCnpj = null;
  public descricao = null;
  public requisitarCartaoId = null;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public criar = null;
  public processar = null;
  public stepCondition =false;
  public stepSelected = null;
  public viewObject = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: GestaoRequisitarCartoesDetailsService,
    private dialogService: NbDialogService,
    private router: Router,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private spinnerService: NgxSpinnerService,
  ) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.requisitarCartaoId = this.encriptyService.decriptyBySecretKey(params.get('id'));

    });

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.buscar(this.requisitarCartaoId);
  }

  buscar(data: any) {

    this.spinnerService.show();
    this.service.buscaOnboardById(data, (response => {
      this.viewObject = response;
      this.criar = this.extractStyle(response.criar);
      this.processar = this.extractStyle(response.processar);
      this.cpfCnpj = DocumentoHelper.formatarDocumento(response.cpfCnpj);
      this.descricao = response.descricao;
      if(this.criar != null){
        this.stepCondition = true;
      }
      this.spinnerService.hide();
    }), (erro) =>{
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  reprocessar() {

    let dataEtapa = null;
    if(this.viewObject.criar === 'FALHA'){
      dataEtapa = 'CRIAR';
    }else if(this.viewObject.processar === 'FALHA'){
      dataEtapa = 'PROCESSAR';
    }

    this.spinnerService.show();
    this.service.reprocess(this.requisitarCartaoId, dataEtapa, null, (response => {

      this.criar = this.extractStyle(response.criar);
      this.processar = this.extractStyle(response.processar);
      this.cpfCnpj = DocumentoHelper.formatarDocumento(response.cpfCnpj);
      this.descricao = response.descricao;
      if(this.criar != null){
        this.stepCondition = true;
      }
      this.spinnerService.hide();
    }), (erro) =>{
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  buscarLog(dataEtapa: any, page?: string) {
    this.stepSelected = dataEtapa;

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))
    params = params.append('sort', 'id,desc')

    if (page) {
      params = params.append('page', page)
    }

    this.spinnerService.show();
    this.service.buscaOnboardLog(this.requisitarCartaoId, dataEtapa, params, (response => {

      this.erroLog = response.content.length;
      this.paginationService.setInfo(response)

      this.spinnerService.hide();
      if (this.erroLog == 0) {
        this.notificationService.warn('Não há dados nesse período!');
      }

    }), (erro) =>{
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  extractStyle(data: any){
    if(data == null || data === 'PENDENTE'){
      return 'step';
    }else if( data === 'FINALIZADO'){
      return 'step completed';
    }else{
      return 'step fail';
    }
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formGestaoOnboarding = this.formBuilder.group({
      cnpjCpf: [null],
      descricao: [null]
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cpfCnpj);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  previousPage() {
    this.router.navigate(['/pages/backoffice/gestao-requisitar-cartoes']);
  }

  showCardModal(data: any) {

    this.dialogService.open(ModalVisualizarRequisitarCartoesComponent, {
      context: {
        text: data,
      },
    });

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
